import { render, staticRenderFns } from "./discountSee.vue?vue&type=template&id=83c2e0be&scoped=true&"
import script from "./discountSee.vue?vue&type=script&lang=js&"
export * from "./discountSee.vue?vue&type=script&lang=js&"
import style0 from "./discountSee.vue?vue&type=style&index=0&id=83c2e0be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c2e0be",
  null
  
)

export default component.exports